import { Component, Inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface LinkDialogData {
  href: string;
}

@Component({
  selector: 'mce-link-editor-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatButtonModule],
  templateUrl: './link-editor-dialog.component.html',
  styleUrl: './link-editor-dialog.component.scss',
})
export class LinkEditorDialogComponent {
  readonly href = signal('');

  constructor(
    private readonly dialogRef: MatDialogRef<LinkEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: LinkDialogData,
  ) {
    this.href.set(data?.href ?? '');
  }

  save() {
    const href = this.href().trim();
    this.dialogRef.close(href || null);
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
